import React from 'react'
import { LOGO_IMAGE } from '../constants/common';
import { useNavigate } from 'react-router-dom';

function RewardsConnectLogo(props) {
  const navigate = useNavigate()
  return (
    <><img onClick={() => navigate("/landing")} alt='logo' src={LOGO_IMAGE} {...props}  /></>
  )
}

export default RewardsConnectLogo